import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Header = styled.div`
  display: flex;
  height: 87px;
  padding: 0 50px;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled(Typography.Header).attrs(() => ({
  $variant: '3',
}))`
  font-size: 22px;
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
  background: none;
  cursor: pointer;
  box-shadow: none;
  width: 25px;
  height: 25px;
`;

export const Footer = styled.div`
  display: flex;
  height: 130px;
  padding: 0 50px;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: sticky;
    top: 100%;
    height: 75px;
    align-items: flex-start;
    padding: 5px 15px 20px 15px;
  }
`;
